import store from '@/store';

export default function (args, to, from, next) {
    store.getters['auth/isAuthenticated']
        ? next()
        : next({ name: 'login' });
}